import React from "react";
import { Box, Typography } from "@mui/material";
import FormButton from "../FormButton";

interface FaultStepProps {
  accidentFault: string;
  onChange: (field: string, value: string) => void;
  setDequalified: () => void; // For the third option
}

const FaultStep: React.FC<FaultStepProps> = ({
  accidentFault,
  onChange,
  setDequalified,
}) => {
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 3 out of 5
      </Typography>

      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        3. Are you at fault for the accident? Be honest{" "}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormButton
          isSelected={accidentFault === "NO"}
          onClick={() => onChange("accidentFault", "NO")}
        >
          No, I am not at fault. The other driver owes damages.
        </FormButton>

        <FormButton
          isSelected={accidentFault === "YES"}
          onClick={() => onChange("accidentFault", "YES")}
        >
          Yes, it was my fault.
        </FormButton>

        <FormButton isSelected={false} onClick={setDequalified}>
          There was no one else there, I hit a tree/fallen object/weather
          problem.
        </FormButton>
      </Box>
    </>
  );
};

export default FaultStep;
